import {createAction} from 'redux-actions'

export const fetch = createAction('SERVERS/FETCH')
export const update = createAction('SERVERS/UPDATE')
